const KEY = "fs.recent-rounds";
const MAX = 50;

export function loadRecentRounds() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return [];
        const arr = JSON.parse(raw);
        if (!Array.isArray(arr)) return [];
        return arr.slice(0, MAX);
    } catch (err) {
        console.warn("recentRounds.load failed:", err);
        return [];
    }
}

export function saveRecentRound(round) {
    if (!round || !round.id) return;
    try {
        const cur = loadRecentRounds();
        const dedup = cur.filter((r) => r.id !== round.id);
        const next = [{ ...round, savedAt: Date.now() }, ...dedup].slice(0, MAX);
        localStorage.setItem(KEY, JSON.stringify(next));
    } catch (err) {
        console.warn("recentRounds.save failed:", err);
    }
}

export function removeRecentRound(id) {
    try {
        const cur = loadRecentRounds();
        localStorage.setItem(
            KEY,
            JSON.stringify(cur.filter((r) => r.id !== id)),
        );
    } catch (err) {
        console.warn("recentRounds.remove failed:", err);
    }
}
